import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url, URLS } from '@wix/da-url';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { getHasResults } from '../../../../selectors/studio';
import AppsTabs from '../../../apps/AppsTabs';
import StudioHeading from '../../../StudioHeading';
import BaseHeader from '../BaseHeader';

import s from './AppsHeader.scss';

export interface Props {
  className?: string;
}

const AppsHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const hasDeviations = useSelector(getHasResults);

  return (
    <BaseHeader
      className={className}
      titleSlot={
        <>
          <StudioHeading>{t('studio.header.tabs.apps')}</StudioHeading>
          <AppsTabs className={s['sub-tabs']} />
        </>
      }
      actions={
        hasDeviations && (
          <TextButton variant="main" size="medium" href={Url.to(URLS.REGISTER_APPLICATION)}>
            {t('studio.header.registerApplication')}
          </TextButton>
        )
      }
    />
  );
};
AppsHeader.displayName = 'AppsHeader';

export default AppsHeader;
